'use client';

import { useEffect, useState } from 'react';

// Custom event to trigger cookie settings modal from anywhere
const COOKIE_SETTINGS_EVENT = 'openCookieSettings';

export const useCookieSettings = () => {
  const openCookieSettings = () => {
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent(COOKIE_SETTINGS_EVENT));
    }
  };

  return { openCookieSettings };
};

// Hook to listen for the cookie settings event (used in CookieConsent component)
export const useCookieSettingsListener = (callback: () => void) => {
  useEffect(() => {
    const handler = () => callback();
    window.addEventListener(COOKIE_SETTINGS_EVENT, handler);
    return () => window.removeEventListener(COOKIE_SETTINGS_EVENT, handler);
  }, [callback]);
};
